export const SEC_TYPE_KEYS = [
  "alarm_response", "general", "event", "hospitality", "aviation", "mobile",
  "object", "education", "investigation", "alarm_center", "private", "personal",
  "doorman", "retail", "healthcare",
];

export const secLabelKey = (k) => `sec_${k}`;

export function secOptions(t) {
  return SEC_TYPE_KEYS
    .map((k) => ({ value: k, label: t(secLabelKey(k)) }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
